<template>
  <div>
    <v-row>
      <v-col cols="12">
        <h1>ОТЧЕТ РАСХОД</h1>
      </v-col>
      <v-col cols="6" sm="6" md="4">
        <oil-date-picker
            itemKey="date1"
            :item="dateSearch"
            :keys="dateKeys"
            :attr="dateKeys.attrs"
            :vInput="input"
        />
      </v-col>
      <v-col cols="6" sm="6" md="4">
        <oil-date-picker
            itemKey="date2"
            :attr="dateKeys.attrs"
            :item="dateSearch"
            :keys="dateKeys"
            :vInput="input"
        />
      </v-col>
      <v-col cols="6" sm="6" md="4">
        <v-btn @click="downloadFile" color="blue" v-text="'ЗАГРУЗИТЬ'"/>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {orderService} from '@/services/OrderService'
import {table, cap} from './expenditure.json'
import xlsx from 'json-as-xlsx'
import {invoiceService} from "@/services/InvoiceService";

export default {
  data: () => ({
    input: {isEdit: true},
    printe: true,
    printe1: true,
    dateKeys: {
      attrs: {
        readonly: false,
        outlined: true,
        dense: true
      }
    },
    dateSearch: {
      date1: '',
      date2: '',
    },
    loading: false,
    orderTitle: cap.title,
    expenditure: []
  }),

  components: {
    OilDatePicker: () => import('@/components/helper/form/oil.date.picker')
  },
  methods: {
    async downloadFile(event) {
      const {date1, date2} = this.dateSearch
      const result = await invoiceService.searchByDate({
        start: date1,
        end: date2,
      })
      if (result.data?.length > 0) {
        const keys = table.keys

        const oderColumns = keys.map(key => {
          return {
            value: key.value,
            label: key.text,
          }
        })
        let sumTons = 0
        let sumNetTotal = 0
        let sumExcise = 0
        let sumTotalNoVAT = 0
        let sumVAT = 0
        let sumTotal = 0

        const func = (value) => {
          if (isNaN(value)) return 0
          return value
        }

        const regular = (value, fixed = 2) => {
          const numb = parseFloat(value)
          if (isNaN(numb)) return '0,00'
          return numb.toFixed(fixed)
              .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')
              .replace('.', ',')
        }

        const regularFromTon = (value, fixed = 2) => {
          const numb = parseFloat(value)
          if (isNaN(numb)) return '0,00'
          const tmp = numb.toFixed(fixed)
              .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')
              .split('.')
          const first = (tmp[0] || '')
          const second = tmp[1].replace(' ', '')
          return `${first},${second}`
        }
        const innFormat = (value) => value.replace(/(\d{3}(?=(?:\d\d\d)+(?!\d)))/g, "$1" + ' ')

        const docum = result.data?.map((expend, index) => {
          const waybill = expend.Waybill
          sumTons += func(parseFloat(waybill?.Item?.AmountInTonne))
          sumNetTotal += func(parseFloat(waybill?.NetTotal))
          sumExcise += func(parseFloat(waybill?.Item?.Excise))
          sumTotalNoVAT += func(parseFloat(waybill?.TotalNoVAT))
          sumVAT += func(parseFloat(waybill?.VAT))
          sumTotal += func(parseFloat(waybill?.Total))
          return {
            Id: ++index,
            CompanyName: expend?.Buyer?.CompanyName,
            TaxNo: innFormat(expend?.Buyer?.TaxNo),
            ContractNumber: expend?.Contract?.Number,
            ProductName: waybill?.Item?.Name,
            WaybillDate: waybill?.ShipmentDate,
            WaybillNumber: `${expend?.Contract?.Number}-${waybill?.Number}`,
            invoiceNumber: `${expend?.Contract?.Number}-${expend?.Number}`,
            InvoiceDate: expend?.InvoiceDate,
            AmountInTonne: regularFromTon(waybill?.Item?.AmountInTonne, 4),
            GrossPricePerTonne: regular(waybill?.Item?.GrossPricePerTonne),
            NetTotal: regular(waybill?.NetTotal),
            Excise: regular(waybill?.Item?.Excise),
            TotalNoVAT: regular(waybill?.TotalNoVAT),
            VAT: regular(waybill?.VAT),
            Total: regular(waybill?.Total),
          }
        })

        docum?.push(
            {
              ContractNumber: 'ИТОГО:',
              AmountInTonne: regular(sumTons),
              NetTotal: regular(sumNetTotal),
              Excise: regular(sumExcise),
              TotalNoVAT: regular(sumTotalNoVAT),
              VAT: regular(sumVAT),
              Total: regular(sumTotal)
            }
        )

        const settings = {
          sheetName: 'РАСХОД - СЧЕТ',
          fileName: `expenditure ${Math.random()}`
        }

        xlsx(oderColumns, [{}, ...docum], settings)
      } else {
        alert("За выбранный период не было найдено записей.")
      }

    }
  }
}
</script>